enum TiposDocumento {
    solicitud_prorroga = 90,
    solicitud_apelacion = 91,
    resolucion = 92,
    resultado_apelacion = 93,
}

export default TiposDocumento;